import React from 'react';
import { LinkProps } from 'react-router-dom';

import { Page } from 'src/api/contentful/contentTypes.cloverdotcom';
import { workaroundRef } from 'src/components/TrackedLink/Util';
import { getField } from 'src/utils/EntryUtil';

import { applyEntryDataAttributes } from '../EntryWrapper/EntryDataWrapper';
import { IContentLink } from './IContentLink';
import { LocaleLink } from './LocaleLink';

export interface IPageLinkProps extends IContentLink<Page>,
  Pick<LinkProps, Exclude<keyof LinkProps, 'to' | 'innerRef' | 'target'>> {
    titleTag?: string;
}

const PageLink: React.FC<IPageLinkProps> = ({
  innerRef, entry, children, hideTitle, titleTag= 'span', ...props
}) => {
  const slug = getField(entry, 'slug');

  if (!slug) return null;

  const title = getField(entry, 'title');

  return (
    <LocaleLink innerRef={node => workaroundRef(node, innerRef)} to={`/${slug}`} title={title} {...props}>
      {!hideTitle && React.createElement(titleTag, '', title)}
      {children}
    </LocaleLink>
  );
};

const Wrapper = applyEntryDataAttributes(PageLink);
export { Wrapper as PageLink };
